// Firebase Auth loads this script to create the iframe that drives the federated auth lifecycle (SAML SSO, social
// IdPs). When the request fails, `@firebase/auth` rejects with a generic `auth/internal-error` (see its `loadJS`,
// which reports `internal-error` whenever the script element fires `onerror`), which tells the customer nothing
// about the real cause. Browsers never expose the underlying network status - e.g. `net::ERR_CONNECTION_REFUSED` -
// to scripts, so the cause has to be narrowed down by checking access ourselves.
//
// Two independent things can stop the script reaching us, each needing different advice for the customer:
//   - the network path being blocked, see `networkAvailability`
//   - the script being blocked from loading, see `scriptAvailability`
//
// This has to stay in step with the URL `@firebase/auth` itself requests, which it keeps private to its module and
// so cannot be imported. `googleApi.test` fails if a Firebase upgrade moves it, and the diagnostics fall silent
// rather than misreport if it goes stale in production.
export const GOOGLE_API_SCRIPT_URL = 'https://apis.google.com/js/api.js'
